import React from "react";

const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

export default function ActiveCallCard({
  dialValue,
  outboundNumber,
  duration,
  isConnected,
  isMuted,
  onMute,
  onEndCall,
}) {
  return (
    <section className="dialer-call-card">
      <div className="dialer-call-card-top">
        <div className="dialer-call-card-info">
          <div className="dialer-section-label">Active call</div>
          <h2 className="dialer-section-title">
            {dialValue || "Unknown destination"}
          </h2>
          <div className="dialer-call-status-row">
            <span className={`dialer-live-dot${isConnected ? "" : " is-waiting"}`} />
            <span>{isConnected ? "Connected" : "Ringing..."}</span>
          </div>
          <div className="dialer-call-detail-row">
            <span>From {outboundNumber}</span>
          </div>
        </div>

        <div className="dialer-duration-box">
          <span className="dialer-duration-label">Duration</span>
          <div className="dialer-duration-value">
            {formatDuration(duration)}
          </div>
        </div>
      </div>

      <div className="dialer-call-flags">
        <span className={`dialer-call-flag${isMuted ? " is-enabled" : ""}`}>
          {isMuted ? "Muted" : "Mic Live"}
        </span>
      </div>

      <div className="dialer-call-actions">
        <button
          type="button"
          onClick={onMute}
          className={`dialer-chip-button dialer-call-control-button${
            isMuted ? " is-active" : ""
          }`}
        >
          {isMuted ? "Unmute" : "Mute"}
        </button>
        <button
          type="button"
          onClick={onEndCall}
          className="dialer-danger-button dialer-call-end-button"
        >
          End Call
        </button>
      </div>
    </section>
  );
}
